"use strict";

var cov_2q14zothyo = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ColumnsMenu.js";
  var hash = "83ae012c36d4ae1cd461753da2e126288edf841b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ColumnsMenu.js",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 29
        },
        end: {
          line: 21,
          column: 63
        }
      },
      "1": {
        start: {
          line: 22,
          column: 24
        },
        end: {
          line: 22,
          column: 29
        }
      },
      "2": {
        start: {
          line: 24,
          column: 29
        },
        end: {
          line: 26,
          column: 3
        }
      },
      "3": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 25,
          column: 47
        }
      },
      "4": {
        start: {
          line: 28,
          column: 29
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "5": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 26
        }
      },
      "6": {
        start: {
          line: 32,
          column: 23
        },
        end: {
          line: 38,
          column: 3
        }
      },
      "7": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 33,
          column: 40
        }
      },
      "8": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 35
        }
      },
      "9": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 35,
          column: 33
        }
      },
      "10": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 36,
          column: 29
        }
      },
      "11": {
        start: {
          line: 37,
          column: 4
        },
        end: {
          line: 37,
          column: 24
        }
      },
      "12": {
        start: {
          line: 40,
          column: 32
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "13": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 44,
          column: 68
        }
      },
      "14": {
        start: {
          line: 49,
          column: 18
        },
        end: {
          line: 49,
          column: 29
        }
      },
      "15": {
        start: {
          line: 51,
          column: 20
        },
        end: {
          line: 81,
          column: 4
        }
      },
      "16": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 80,
          column: 15
        }
      },
      "17": {
        start: {
          line: 59,
          column: 29
        },
        end: {
          line: 59,
          column: 48
        }
      },
      "18": {
        start: {
          line: 69,
          column: 33
        },
        end: {
          line: 69,
          column: 58
        }
      },
      "19": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 117,
          column: 4
        }
      },
      "20": {
        start: {
          line: 84,
          column: 63
        },
        end: {
          line: 84,
          column: 75
        }
      },
      "21": {
        start: {
          line: 120,
          column: 18
        },
        end: {
          line: 123,
          column: 3
        }
      },
      "22": {
        start: {
          line: 120,
          column: 41
        },
        end: {
          line: 123,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "ColumnsMenu",
        decl: {
          start: {
            line: 18,
            column: 9
          },
          end: {
            line: 18,
            column: 20
          }
        },
        loc: {
          start: {
            line: 20,
            column: 3
          },
          end: {
            line: 118,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 29
          },
          end: {
            line: 24,
            column: 30
          }
        },
        loc: {
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 26,
            column: 3
          }
        },
        line: 24
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 29
          },
          end: {
            line: 28,
            column: 30
          }
        },
        loc: {
          start: {
            line: 28,
            column: 40
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 23
          },
          end: {
            line: 32,
            column: 24
          }
        },
        loc: {
          start: {
            line: 32,
            column: 34
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 41,
            column: 5
          }
        },
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 68
          }
        },
        line: 42
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 51,
            column: 32
          },
          end: {
            line: 51,
            column: 33
          }
        },
        loc: {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 80,
            column: 15
          }
        },
        line: 52
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 59,
            column: 24
          }
        },
        loc: {
          start: {
            line: 59,
            column: 29
          },
          end: {
            line: 59,
            column: 48
          }
        },
        line: 59
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 69,
            column: 27
          },
          end: {
            line: 69,
            column: 28
          }
        },
        loc: {
          start: {
            line: 69,
            column: 33
          },
          end: {
            line: 69,
            column: 58
          }
        },
        line: 69
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 84,
            column: 57
          },
          end: {
            line: 84,
            column: 58
          }
        },
        loc: {
          start: {
            line: 84,
            column: 63
          },
          end: {
            line: 84,
            column: 75
          }
        },
        line: 84
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 120,
            column: 29
          },
          end: {
            line: 120,
            column: 30
          }
        },
        loc: {
          start: {
            line: 120,
            column: 41
          },
          end: {
            line: 123,
            column: 1
          }
        },
        line: 120
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 68
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 42,
            column: 15
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 43,
            column: 24
          }
        }, {
          start: {
            line: 44,
            column: 8
          },
          end: {
            line: 44,
            column: 68
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 78,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 63,
            column: 9
          },
          end: {
            line: 63,
            column: 38
          }
        }, {
          start: {
            line: 64,
            column: 10
          },
          end: {
            line: 77,
            column: 17
          }
        }],
        line: 63
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    b: {
      "0": [0, 0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "83ae012c36d4ae1cd461753da2e126288edf841b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _icons = require("@material-ui/icons");

var _localStrings = require("../../core/localStrings");

var _Resources = require("../resources/Resources.context");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function ColumnsMenu(_ref) {
  var columns = _ref.columns,
      onColumns = _ref.onColumns,
      anchorEl = _ref.anchorEl,
      onAnchorEl = _ref.onAnchorEl;
  cov_2q14zothyo.f[0]++;

  var _ref2 = (cov_2q14zothyo.s[0]++, _react.default.useContext(_Resources.ResourcesContext)),
      state = _ref2.state,
      actions = _ref2.actions;

  var _ref3 = (cov_2q14zothyo.s[1]++, state),
      resources = _ref3.resources;

  cov_2q14zothyo.s[2]++;

  var onResourceAddClick = function onResourceAddClick() {
    cov_2q14zothyo.f[1]++;
    cov_2q14zothyo.s[3]++;
    actions.addResourceLink(resourceUrl.value);
  };

  cov_2q14zothyo.s[4]++;

  var removeResourceLink = function removeResourceLink(index) {
    cov_2q14zothyo.f[2]++;
    cov_2q14zothyo.s[5]++;
    actions.remove(index);
  };

  cov_2q14zothyo.s[6]++;

  var toggleColumn = function toggleColumn(index) {
    cov_2q14zothyo.f[3]++;
    var column = (cov_2q14zothyo.s[7]++, _objectSpread({}, columns[index]));
    cov_2q14zothyo.s[8]++;
    column.hidden = !column.hidden;

    var _columns = (cov_2q14zothyo.s[9]++, (0, _toConsumableArray2.default)(columns));

    cov_2q14zothyo.s[10]++;
    _columns[index] = column;
    cov_2q14zothyo.s[11]++;
    onColumns(_columns);
  };

  var isDefaultResourceLink = (cov_2q14zothyo.s[12]++, _react.default.useCallback(function (index) {
    cov_2q14zothyo.f[4]++;
    cov_2q14zothyo.s[13]++;
    return (cov_2q14zothyo.b[0][0]++, resources) && (cov_2q14zothyo.b[0][1]++, resources[index]) && (cov_2q14zothyo.b[0][2]++, actions.isDefaultResourceLink(resources[index].resourceLink));
  }, [actions, resources]));
  var classes = (cov_2q14zothyo.s[14]++, useStyles());
  var menuItems = (cov_2q14zothyo.s[15]++, columns.map(function (col, index) {
    cov_2q14zothyo.f[5]++;
    cov_2q14zothyo.s[16]++;
    return _react.default.createElement(_core.MenuItem, {
      key: col.id
    }, _react.default.createElement(_core.Grid, {
      container: true,
      justify: "space-between"
    }, _react.default.createElement(_core.Grid, {
      item: true
    }, _react.default.createElement("div", null, _react.default.createElement(_core.FormControlLabel, {
      label: col.label,
      control: _react.default.createElement(_core.Checkbox, {
        checked: !col.hidden
      }),
      onClick: function onClick() {
        cov_2q14zothyo.f[6]++;
        cov_2q14zothyo.s[17]++;
        return toggleColumn(index);
      }
    }))), (cov_2q14zothyo.b[1][0]++, !isDefaultResourceLink(index)) && (cov_2q14zothyo.b[1][1]++, _react.default.createElement(_core.Grid, {
      item: true
    }, _react.default.createElement("div", null, _react.default.createElement(_core.Tooltip, {
      title: (0, _localStrings.localString)('Remove'),
      arrow: true
    }, _react.default.createElement(_core.IconButton, {
      "aria-label": (0, _localStrings.localString)('Remove'),
      onClick: function onClick() {
        cov_2q14zothyo.f[7]++;
        cov_2q14zothyo.s[18]++;
        return removeResourceLink(index);
      },
      className: classes.action,
      size: "small"
    }, _react.default.createElement(_icons.HighlightOff, null))))))));
  }));
  cov_2q14zothyo.s[19]++;
  return _react.default.createElement(_core.Menu, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: function onClose() {
      cov_2q14zothyo.f[8]++;
      cov_2q14zothyo.s[20]++;
      return onAnchorEl();
    }
  }, _react.default.createElement(_core.MenuItem, {
    key: 'text',
    disabled: true,
    style: {
      opacity: 1,
      fontWeight: 600,
      fontSize: 12
    }
  }, (0, _localStrings.localString)('ManageVersions')), menuItems, _react.default.createElement(_core.MenuItem, null, _react.default.createElement(_core.TextField, {
    id: "resourceUrl",
    label: (0, _localStrings.localString)('ResourcePath'),
    variant: "outlined",
    defaultValue: "",
    style: {
      valign: 'middle'
    }
  }), _react.default.createElement(_core.Tooltip, {
    title: (0, _localStrings.localString)('AddResource'),
    arrow: true
  }, _react.default.createElement(_core.IconButton, {
    "aria-label": (0, _localStrings.localString)('AddResource'),
    onClick: onResourceAddClick,
    className: (classes.action, classes.menuIconButton),
    size: "small"
  }, _react.default.createElement(_icons.PlaylistAdd, {
    fontSize: "small"
  })))));
}

var useStyles = (cov_2q14zothyo.s[21]++, (0, _styles.makeStyles)(function (theme) {
  cov_2q14zothyo.f[9]++;
  cov_2q14zothyo.s[22]++;
  return {
    root: {},
    action: {
      padding: '8px'
    }
  };
}));
var _default = ColumnsMenu;
exports.default = _default;